import React from 'react';
import * as Icon from 'react-feather';
import { useQuery } from 'react-query';
import { api_srv } from 'services';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { formatDate } from 'utils/helpers';

const styles = `
  .single-policy-container {
    padding: 24px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: #2563eb;
  }
  .info-card {
    margin-bottom: 24px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
  }
  .info-card-header {
    display: flex;
    align-items: center;
    padding: 16px;
    background-color: #f9fafb;
  }
  .info-card-body {
    padding: 16px;
  }
  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }
  .info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .info-label {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }
  .info-value-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .info-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }
  .info-icon.blue {
    background-color: #dbeafe;
  }
  .info-icon.green {
    background-color: #d1fae5;
  }
  .info-icon.purple {
    background-color: #ede9fe;
  }
  .info-icon.orange {
    background-color: #ffedd5;
  }
  .info-icon.yellow {
    background-color: #fef3c7;
  }
  .info-icon.red {
    background-color: #fee2e2;
  }
  .loading, .error {
    text-align: center;
    padding: 24px;
    color: #1f2937;
  }
  .error {
    color: #dc2626;
  }
`;

function SinglePolicy() {
  const { id: policyId } = useParams();

  const getPolicy = async () => {
    const resp = await (await api_srv).fetchPolicyDetails(policyId);
    return resp.data;
  };

  const { data: policyRes, isLoading, error } = useQuery('policy', getPolicy);
  
  const policy = policyRes?.length> 0 ?  policyRes[0] : [];
  console.log("POLICY DETAILS", policy.product_details)

  return (
    <div className="single-policy-container">
      <style>{styles}</style>
      <div className="header">
        {/* <div className="icon-container">
          <Icon.Eye size={24} style={{ color: 'white' }} />
        </div> */}
        {/* <div>
          <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
            Policy Details
          </h3>
        </div> */}
      </div>

      {isLoading ? (
        <div className="loading">Loading policy details...</div>
      ) : error ? (
        <div className="error">Error fetching policy: {error.message}</div>
      ) : policy ? (
        <div className="content">

          {/* Policy Information */}
          <div className="info-card">
            <div className="info-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <p className="info-label">Product Name</p>
                  <div className="info-value-container">
                    <div className="info-icon blue">
                      <Icon.Shield size={14} style={{ color: '#2563eb' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.product_details[0]?.productName || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Policy Number</p>
                  <div className="info-value-container">
                    <div className="info-icon blue">
                      <Icon.Hash size={14} style={{ color: '#2563eb' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.policyNumber || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Insurance Class</p>
                  <div className="info-value-container">
                    <div className="info-icon purple">
                      <Icon.Briefcase size={14} style={{ color: '#7c3aed' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.product_details[0]?.insuranceCategory || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Underwriter</p>
                  <div className="info-value-container">
                    <div className="info-icon orange">
                      <Icon.Home size={14} style={{ color: '#ea580c' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.underwriter[0]?.name || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Start Date</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Calendar size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {formatDate(policy.policyCover?.startDate) || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">End Date</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Calendar size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {formatDate(policy.policyCover?.endDate) || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Amount</p>
                  <div className="info-value-container">
                    <div className="info-icon yellow">
                      <Icon.Briefcase size={14} style={{ color: '#d97706' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.quotationPremium?.totalPremium
                        ? `${policy.quotationPremium.totalPremium.toFixed(2)} ${policy.quotationCurrency || ''}`
                        : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Client Information */}
          <div className="info-card">
            <div className="info-card-header">
              <Icon.User size={20} style={{ color: '#2563eb', marginRight: '12px' }} />
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                Client Information
              </h3>
            </div>
            <div className="info-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <p className="info-label">Client Name</p>
                  <div className="info-value-container">
                    <div className="info-icon blue">
                      <Icon.User size={14} style={{ color: '#2563eb' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.client_details?.[0]?.names?.firstName} {policy.client_details?.[0]?.names?.middleName} {policy.client_details?.[0]?.names?.lastName}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Phone Number</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Phone size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.client_details?.[0]?.phone || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Email Address</p>
                  <div className="info-value-container">
                    <div className="info-icon red">
                      <Icon.Mail size={14} style={{ color: '#dc2626' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.client_details?.[0]?.email || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Risks Section */}
          <div className="info-card">
            <div className="info-card-header">
              <Icon.AlertTriangle size={20} style={{ color: '#2563eb', marginRight: '12px' }} />
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                Risks
              </h3>
            </div>
            <div className="info-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <p className="info-label">Registration Number</p>
                  <div className="info-value-container">
                    <div className="info-icon blue">
                      <Icon.Hash size={14} style={{ color: '#2563eb' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.risks?.[0]?.riskRef || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Asset Value</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Briefcase size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.risks?.[0]?.value
                        ? `${policy.risks[0].value.toLocaleString()} ${policy.quotationCurrency || ''}`
                        : 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Car Make</p>
                  <div className="info-value-container">
                    <div className="info-icon purple">
                      <Icon.Truck size={14} style={{ color: '#7c3aed' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.risks?.[0]?.details?.make || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Model</p>
                  <div className="info-value-container">
                    <div className="info-icon orange">
                      <Icon.Truck size={14} style={{ color: '#ea580c' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.risks?.[0]?.details?.model || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="info-card">
            <div className="info-card-header">
              <Icon.CreditCard size={20} style={{ color: '#2563eb', marginRight: '12px' }} />
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                Payment Information
              </h3>
            </div>
            <div className="info-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <p className="info-label">Payment Status</p>
                  <div className="info-value-container">
                    <div className="info-icon blue">
                      <Icon.Calendar size={14} style={{ color: '#2563eb' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.policyPayment?.paymentStatus || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Payment Amount</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Briefcase size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.quotationPremium?.totalPremium ?? 0} {policy.quotationCurrency || ''}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Payment Frequency</p>
                  <div className="info-value-container">
                    <div className="info-icon green">
                      <Icon.Briefcase size={14} style={{ color: '#059669' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.policyPayment?.paymentFrequency || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <p className="info-label">Next Payment Date</p>
                  <div className="info-value-container">
                    <div className="info-icon red">
                      <Icon.Hash size={14} style={{ color: '#dc2626' }} />
                    </div>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>
                      {policy.policyPayment?.nextPaymentDate 
                        ? formatDate(policy.policyPayment.nextPaymentDate) 
                        : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="content">
          <p style={{ color: '#dc2626', textAlign: 'center' }}>
            No valid policy data available.
          </p>
        </div>
      )}
    </div>
  );
}

export default SinglePolicy;